export default function ServicesPage() {
  return (
    <div className="container py-5">
      <header className="text-center mb-5">
        <h1 className="display-4 fw-bold">Our Services</h1>
        <p className="text-muted fs-5">
          Explore how I can assist you with programming projects and personalized education.
        </p>
      </header>

      <div className="row g-4">
        {/* Programming Projects */}
        <div className="col-md-4">
          <div className="card h-100 shadow-sm border-0">
            <div className="card-body text-start d-flex flex-column align-items-center">
              <img src="https://res.cloudinary.com/dfs2sqkxy/image/upload/v1766292993/MyServices_prfqw0.png" alt="Programming" width={200} className="mb-3" />
              <h5 className="card-title fw-bold">Programming Projects</h5>
              <p className="card-text text-muted" style={{ textAlign: 'justify' }}>
                Custom development for web applications, desktop software, and more — fully tailored to your specific needs.
                Whether you require a modern user-friendly interface, a powerful backend system, or a complete end-to-end solution,
                I can build it for you from the ground up. I ensure clean, secure, and scalable code designed to grow with your project.
                Let’s turn your ideas into a reliable, high-quality software product that truly works for you.
              </p>
            </div>
          </div>
        </div>

        {/* Personalized Tutoring */}
        <div className="col-md-4">
          <div className="card h-100 shadow-sm border-0">
            <div className="card-body text-start d-flex flex-column align-items-center">
              <img src="https://res.cloudinary.com/dfs2sqkxy/image/upload/v1766293036/Tutoring_faweeh.png" alt="Tutoring" width={200} className="mb-3" />
              <h5 className="card-title fw-bold">Personalized Tutoring</h5>
              <p className="card-text text-muted" style={{ textAlign: 'justify' }}>
                In-person or online lessons in computer science, programming, and high school mathematics — fully tailored to each student’s level and goals.
                Whether you need help understanding core concepts, improving grades, or preparing for exams, I provide clear explanations and structured learning plans.
                With practical examples and step-by-step guidance, students gain confidence and real problem-solving skills.
                Let’s build a strong foundation together and make learning both effective and enjoyable.
              </p>
            </div>
          </div>
        </div>

        {/* Online Education */}
        <div className="col-md-4">
          <div className="card h-100 shadow-sm border-0">
            <div className="card-body text-start d-flex flex-column align-items-center">
              <img src="https://res.cloudinary.com/dfs2sqkxy/image/upload/v1766293010/OnlineEducation_hs29pb.png" alt="Online Education" width={200} className="mb-3" />
              <h5 className="card-title fw-bold">Online Education</h5>
              <p className="card-text text-muted" style={{ textAlign: 'justify' }}>
                Flexible online courses to learn programming and computer science at your own pace.
                Each course is structured with clear explanations, hands-on exercises, and real-world examples to help you truly understand every concept.
                Whether you are a complete beginner or looking to expand your existing skills, you can study anytime and progress step by step with full guidance.
                Learn comfortably, confidently, and efficiently with courses designed to fit your schedule and goals.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="text-center mt-5">
        <a href="/contact" className="btn btn-primary btn-lg px-4">
          Contact Me
        </a>
      </div>
    </div>
  );
}
